import React from "react";
import { colors } from "../../../designSystem/colors/color";
import { ActivityListing, ActivityType } from "../../../amorg-common";
import { txt } from "../../../txt";
import { TimelineGraph } from "../../../designSystem/graphs/TimelineGraph";
import { TimelineGraphEvent } from "../../../designSystem/graphs/timelineGraph/TimelineGraphYearRow";
import { toDateString } from "../../../utils/date";


type ActivityGraphProps = {
    rowHeightPx: number,
    yearMonthStart: Date,
    activities: ActivityListing[],
    onNavigate?: (yearMonthStart: Date) => void;
};
export function ActivityGraph (props: ActivityGraphProps): JSX.Element
{
    const shownTypes:ActivityType[] = [
        'WorkgroupMeeting',
        'AnnualWorkgroupStatus',
        'WorkplaceAssessment',
        'SafetyInspection',
        'CustomForm'
    ];

    return (
        <TimelineGraph
            headerText="Aktuelle aktiviteter"
            yearMonthStart={props.yearMonthStart}
            eventGroups={shownTypes.map((type) => ({
                legend: {
                    text: type === 'CustomForm'
                        ? 'Ergonomisk undersøgelse'
                        : txt.getDynamic(`ActivityType_${type}`),
                    color: colors.graphs.activityTimeline.getColor(type)
                },
                events: props.activities
                    .filter((a) => a.activityType === type)
                    .map((a) => ({
                        id: a.id,
                        label: a.title,
                        linkUrl: getLink(a),
                        start: a.start,
                        end: a.end,
                        color: getColor(a),
                        toolTip: <>
                                    <b>{a.title}</b><br />
                                    <small dangerouslySetInnerHTML={{ __html: a.description }} /><br />
                                    
                                    <small>{toDateString(a.start)} - {toDateString(a.end)}</small>
                                </>,
                        isDot: a.end.getTime() - a.start.getTime() <= 1000 * 60 * 60 * 24 * 7 // 7 days
                    } satisfies TimelineGraphEvent))

            }))}
            onNavigate={props.onNavigate}
        />
    );
}

function getLink(a: ActivityListing): string 
{
    if(a.activityType === 'WorkgroupMeeting')
        return `/workgroupmeetings/${a.id}`;
    else if(a.activityType === 'AnnualWorkgroupStatus')
        return `/annualworkgroupstatus/${a.id}`;
    else if(a.activityType === 'WorkplaceAssessment')
        return `/workplaceassessments/${a.id}`;
    else if(a.activityType === 'SafetyInspection')
        return `/safetyinspections/${a.id}`;
    else if(a.activityType === 'CustomForm')
        return `/customforms/${a.id}`;
    else
        return '#';
}

function getColor(a: ActivityListing): string 
{
    return colors.graphs.activityTimeline.getColor(a.activityType);
}